export interface User {
  id: number;
  firstName: string;
  lastName: string;
  username: string;
  phoneNumber: string;
  preferredLanguage?: string | null;
  passwordCode?: string | null;
  role: UserRole;
  status: UserStatus;
  emailVerified: boolean;
  phoneVerified: boolean;
  company?: {
    id: number;
    name: string;
    currency?: 'LEK' | 'EUR';
  };
  linkedEmployee?: {
    id: number;
    employeeCode?: string;
    fullName: string;
    status: 'ACTIVE' | 'INACTIVE';
  };
  permissions: {
    canManageFleet: boolean;
    canManageReservations: boolean;
    canManageEmployees: boolean;
    canViewReports: boolean;
    canManageFinances: boolean;
  };
}

export enum UserRole {
  USER = 'USER',
  ADMIN = 'ADMIN',
  SUPERUSER = 'SUPERUSER'
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
  BANNED = 'BANNED'
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface RegisterRequest {
  firstName: string;
  lastName: string;
  username: string;
  password: string;
  confirmPassword?: string; // Frontend-only field for validation
  phoneNumber: string;
  dateOfBirth?: string;
  driverLicenseNumber?: string;
  licenseExpiryDate?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  role?: UserRole;
  companyId?: number;
  employeeId?: string;
  department?: string;
  hireDate?: string;
}

export interface AuthResponse {
  token: string;
  type: string;
  expiresIn: number;
  user: User;
  message?: string;
}

export interface UpdateProfileRequest {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  dateOfBirth?: string;
  driverLicenseNumber?: string;
  licenseExpiryDate?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  emailNotifications?: boolean;
  smsNotifications?: boolean;
  preferredLanguage?: string;
}
